import React, { useState } from 'react';
import {
    Card,
    CardContent,
    Typography,
    Button,
    Box,
    CardMedia,
    Grid,
    Dialog,
    DialogContent,
    DialogActions
} from '@mui/material';
import IconButton from "@mui/material/IconButton";
import { DeleteForever } from "@mui/icons-material";
import ReactQuill from 'react-quill';
import axios from "../../config/axios";
import { useLocalizedContent } from '../../utils/localizedContent';
import { useTranslation } from 'react-i18next';

import 'react-quill/dist/quill.bubble.css';

function NewsCard({
    id, addressId, userId, title, body, translations, thumbnail, newsTimestamp, created, modified,
    user, token
}) {
    const { t } = useTranslation();
    const [expandedDescription, setExpandedDescription] = useState(false);
    const [deleteNewsDialog, setDeleteNewsDialog] = useState(false);

    const localizedTitle = useLocalizedContent({ title, translations }, 'title');
    const localizedBody = useLocalizedContent({ body, translations }, 'body');

    const handleExpandDescription = () => {
        setExpandedDescription(!expandedDescription);
    };

    const handleDialogClose = () => {
        setDeleteNewsDialog(false);
    }

    function deleteNews() {
        axios({
            method: 'delete',
            url: `/user/news/${id}`,
            headers: {
                'token': token
            }
        }).then((response) => {
            console.log('Deleted news = ', response.data);
        }).catch(error => {
            console.error(error);
        });

        handleDialogClose();
    }

    const linebreakRegex = /<p>(.*?)<\/p>/g;
    const linebreaks = (localizedBody?.match(linebreakRegex) || []).length;
    return (
        <div className="m-3">
            <Card sx={{ display: 'flex' }}>
                <Grid container direction={'column'}>
                    <Grid item container direction={'row'}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', maxWidth: '70%', width: '70%' }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography gutterBottom variant="h5" component="div">
                                        {localizedTitle}
                                    </Typography>
                                    {(user?.authRole === 'admin') &&
                                        <IconButton onClick={() => setDeleteNewsDialog(true)}>
                                            <DeleteForever sx={{ color: 'red' }} />
                                        </IconButton>
                                    }
                                </Box>
                                <Typography variant="body2" color="text.secondary">
                                    {newsTimestamp}
                                </Typography>
                                {(localizedBody) &&
                                    <>
                                        <Box sx={{
                                            overflow: 'hidden',
                                            height: expandedDescription ? 'none' : '4.4em'
                                        }}>
                                            <ReactQuill
                                                value={localizedBody}
                                                readOnly={true}
                                                theme={'bubble'}
                                            />
                                        </Box>
                                        {(localizedBody.length > 100 || linebreaks > 3) && (
                                            <Button onClick={handleExpandDescription}>
                                                {expandedDescription ? 'Read Less' : 'Read More'}
                                            </Button>
                                        )}
                                    </>}
                            </CardContent>
                        </Box>
                        <Box
                            sx={{
                                width: '30%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                bgcolor: 'rgba(0, 0, 0, 0.05)',
                            }}
                        >
                            <CardMedia
                                style={{ maxHeight: '100%', maxWidth: '100%', padding: '16px' }}
                                component={'img'}
                                src={thumbnail ? thumbnail : '/vividKidsLogo.svg'}
                                title={'News thumbnail'} />
                        </Box>
                    </Grid>
                </Grid>
            </Card>
            <Dialog open={deleteNewsDialog} onClose={handleDialogClose}>
                <DialogContent>
                    <Box>
                       {t('EventsPage.NewsEvents.DeleteNews')}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={deleteNews} color="primary">
                        {t('EventsPage.Yes')}
                    </Button>
                    <Button onClick={handleDialogClose} color="primary">
                        {t('EventsPage.No')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default NewsCard;
